/**
 * *Shangri-La Hotels*
 *
 * @exports partnership_380
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
          * @memberOf module:partnership_380
          */
    partnership.getId = function getId() {
        return '380';
    };
    /**
          * @memberOf module:partnership_380
          */
    partnership.check = function check() {
        return !!window.location.hostname.match(/www.shangri-la.com/);
    };
    /**
          * @memberOf module:partnership_380
          */
    partnership.getHotelId = function getHotelId() {
        const pageData = window.__pageData;
        const hotelId = pageData?.hotelBasicData?.hotelCode || pageData?.hotelDetail?.code || pageData?.queryObj?.hotelCode || thn.parseUrlParameter('hotelCode') || window.wa?.HotelCode;
        const result = {};
        if (hotelId) {
            result.partnership_hotel_id = hotelId;
        }
        else {
            result.account_key = '40C5E2E97FAE680126E72C5400580B9F';
        }
        return result;
    };
    return partnership;
}

export { factory };
